import React, {useEffect} from 'react';
import classNames from 'classnames';
import {useAnimationsContext} from '../../../contexts';
import styles from './WaterImage.module.scss';

interface WaterImageProps extends Omit<React.HTMLProps<HTMLImageElement>, 'src' | 'alt'> {
  className?: string;
}

const tuningOffset = 750;

const WaterImage = ({className, ...props}: WaterImageProps) => {
  const {animationDuration, animations} = useAnimationsContext();

  useEffect(() => {
    if (animations.water.isOpen) {
      setTimeout(animations.water.hide, animationDuration - tuningOffset);
    }
  }, [animations.water.isOpen]);

  return animations.water.isOpen && (
    <img src={animations.water.image} alt="water" className={classNames(styles.image, className)} {...props} />
  );
};

export default WaterImage;